import { render, staticRenderFns } from "./BattleRoomData.vue?vue&type=template&id=c65cf148&scoped=true&"
import script from "./BattleRoomData.vue?vue&type=script&lang=js&"
export * from "./BattleRoomData.vue?vue&type=script&lang=js&"
import style0 from "./BattleRoomData.vue?vue&type=style&index=0&id=c65cf148&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c65cf148",
  null
  
)

export default component.exports